import PubNub from 'pubnub';
import config from '../../config';

const pubnub = new PubNub({
  uuid: PubNub.generateUUID(),
  publishKey: config.pubnubPublishKey,
  subscribeKey: config.pubnubSubscribeKey,
  ssl: true,
  restore: true,
  heartbeatInterval: 0,
});

const subscriptions = {};
const statusSubscriptions = {};

pubnub.addListener({
  message: (message) => {
    if (subscriptions[message.channel]) {
      subscriptions[message.channel](message);
    }
  },
  status: (message) => {
    if (statusSubscriptions[message.category]) {
      statusSubscriptions[message.category](message);
    }
  },
});

export const setBarberFilter = (barberId) => {
  pubnub.setFilterExpression(`barberId == '${barberId}' || barberId == undefined`);
};

export const unsetBarberFilter = () => {
  pubnub.setFilterExpression('');
};

export const subscribe = (options) => {
  // subscribe only if not subscribed
  if (subscriptions[options.channel]) {
    return;
  }
  subscriptions[options.channel] = options.message;
  pubnub.subscribe({
    channels: [options.channel],
    timetoken: Date.now() * 10000,
  });
};

export const unsubscribe = (channel) => {
  delete subscriptions[channel];
  pubnub.unsubscribe({
    channels: [channel],
  });
};

export default pubnub;
